import React, { ComponentProps, ComponentType, JSXElementConstructor } from 'react';
import cx from 'classnames';
import * as styles from './Text.module.scss';

type Props<TComponentType extends JSXElementConstructor<any>> =
  ComponentProps<TComponentType> & {
    as?: ComponentType;
  };

const PageTitle = <TComponentType extends JSXElementConstructor<any>>({
  as: Component = 'h1',
  children,
  ...props
}: Props<TComponentType>) => (
  <Component {...props} className={cx(styles.pageTitle, props.className)}>
    {children}
  </Component>
);

export default PageTitle;
